import { IntegrationIconProps } from './types';

const VsCode = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0016 3.11679C21.0016 2.23783 20.0175 2.23782 19.5801 2.34769C20.1924 1.86426 20.9105 1.98147 21.1656 2.12796L27.079 5.02747C27.6424 5.30375 27.9998 5.8786 27.9998 6.50857V25.5831C27.9998 26.2215 27.6329 26.8025 27.058 27.0743L21.4937 29.7054C21.1109 29.8701 20.2799 30.2767 19.5801 29.7053C20.4549 29.8702 20.9287 29.2476 21.0016 28.8264V3.11679Z"
      fill="url(#paint0_linear_1334_1578)"
    />
    <path
      d="M19.6512 2.33178C20.1154 2.24004 21.0018 2.28259 21.0018 3.11673V9.68241L3.07359 23.2452C2.76022 23.4823 2.3192 23.4429 2.05229 23.1541L0.204532 21.1547C-0.0849358 20.8415 -0.0646824 20.3512 0.249624 20.0631L19.5802 2.34763L19.6512 2.33178Z"
      fill="url(#paint1_linear_1334_1578)"
    />
    <path
      d="M21.0018 22.3706L3.07359 8.80783C2.76022 8.57076 2.3192 8.61009 2.05229 8.89891L0.204532 10.8983C-0.0849358 11.2115 -0.0646824 11.7018 0.249624 11.9899L19.5802 29.7054C20.455 29.8702 20.9289 29.2476 21.0018 28.8264V22.3706Z"
      fill="url(#paint2_linear_1334_1578)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_1578"
        x1="23.79"
        y1="2"
        x2="23.79"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32B5F1" />
        <stop offset="1" stopColor="#2B9FED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1334_1578"
        x1="21.0018"
        y1="5.53386"
        x2="1.0217"
        y2="22.305"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F6FB3" />
        <stop offset="0.270551" stopColor="#1279B7" />
        <stop offset="0.421376" stopColor="#1176B5" />
        <stop offset="0.618197" stopColor="#0E69AC" />
        <stop offset="0.855344" stopColor="#0F70AF" />
        <stop offset="1" stopColor="#0F6DAD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1334_1578"
        x1="1.15522"
        y1="9.9837"
        x2="21.0791"
        y2="26.4807"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1791D2" />
        <stop offset="1" stopColor="#1173C5" />
      </linearGradient>
    </defs>
  </svg>
);
export default VsCode;
